import React from "react";
import { useSelector } from "react-redux";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import LiveBCAPendingLogsStructure from "../../components/live-subscriptions/live-bca/LiveBCAPendingLogsStructure";

const LiveBCAPending = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Live BCA Pending Logs">
      <LiveBCAPendingLogsStructure userInfoData={userInfoData} />
    </HelmetWrapper>
  );
};

export default LiveBCAPending;
